import { render, staticRenderFns } from "./DashboardReportCustomer.vue?vue&type=template&id=c51904a4&scoped=true&"
import script from "./DashboardReportCustomer.vue?vue&type=script&lang=js&"
export * from "./DashboardReportCustomer.vue?vue&type=script&lang=js&"
import style0 from "./DashboardReportCustomer.vue?vue&type=style&index=0&id=c51904a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c51904a4",
  null
  
)

component.options.__file = "DashboardReportCustomer.vue"
export default component.exports